import React from "react"
import styled from "styled-components"
import {Row, Col} from "@irati/ui/src/Layout"

import ErrorText from "@irati/ui/src/ErrorText"
import Error from "@irati/ui/src/Loading/Error"
import {ValidationButton} from "@irati/ui/src/FormItem"
import {ApolloState} from "@irati/utils/services/apollo/apolloStateInterface"
import {FormattedMessage, useIntl} from "@irati/utils/lang"

const MobileValidationButton = styled(ValidationButton)`
  margin-bottom: ${({theme}) => theme.spacing.one};
`

const StyledError = styled.div`
  margin-bottom: ${({theme}) => theme.spacing.one};
`

interface Props {
  onNext: () => void
  apolloState: ApolloState
  trophyValidationError: boolean
  nextText?: string | null
  id?: string | null
}

const CTA = (props: Props) => {
  const intl = useIntl()
  const {onNext, nextText, id, trophyValidationError, apolloState} = props
  return (
    <Row>
      {(apolloState.error || trophyValidationError) && (
        <Col xs={12}>
          <StyledError>
            {trophyValidationError ? (
              <ErrorText>{intl.formatMessage({id: "recognition.popup.shared.cta.noTrophySelected.message"})}</ErrorText>
            ) : (
              <Error errorMsg={apolloState.errorMsg} error={apolloState.error} />
            )}
          </StyledError>
        </Col>
      )}
      <Col xs={12} smHidden mdHidden lgHidden>
        <MobileValidationButton id={id} apolloState={apolloState} onClick={onNext} primary large full>
          {nextText || <FormattedMessage id="recognition.popup.shared.cta.launch" />}
        </MobileValidationButton>
      </Col>
      <Col xsHidden sm={12}>
        <ValidationButton id={id} onClick={onNext} apolloState={apolloState} primary large full>
          {nextText || <FormattedMessage id="recognition.popup.shared.cta.launch" />}
        </ValidationButton>
      </Col>
    </Row>
  )
}
export default CTA
